module.exports = __webpack_public_path__ + "img/about_member_kaji.e0b8bb24.png";